import {ErrorBoundary} from '@github-ui/react-core/error-boundary'
import {PullRequestErrorState} from '../components/PullRequestErrorState'

export function FilesEntrypoint() {
  return (
    <ErrorBoundary critical fallback={<PullRequestErrorState text="Changes cannot be loaded" />}>
      <Files />
    </ErrorBoundary>
  )
}

export function Files() {
  return <div>Diffs go here</div>
}

try{ FilesEntrypoint.displayName ||= 'FilesEntrypoint' } catch {}
try{ Files.displayName ||= 'Files' } catch {}